import React from 'react';
import { GridTableDatum, SurveyTableContainer, SurveyTableEmptyRow, SURVEY_TABLE_STYLES } from '../styles';
import { Center } from '../../../components/styles';
import SurveyTableHeaders from './SurveyTableHeaders';
import SurveyAnswerRow from './SurveyAnswerRow';

interface SurveyAnswer {
  value: string;
}

interface Subscription {
  subscriber: {
    name?: string;
    last_name?: string;
    email: string;
  };
}

interface SurveyAnswers {
  subscription: Subscription;
  answers: SurveyAnswer[];
}

interface SurveyField {
  caption: string;
}

interface SurveyAnswersTableProps {
  survey?: {
    fields?: SurveyField[];
  };
  allSurveyAnswers?: {
    has_answers: boolean;
    survey_answers?: SurveyAnswers[];
  };
  loading?: boolean;
}

const SurveyAnswersTable: React.FC<SurveyAnswersTableProps> = ({
  survey,
  allSurveyAnswers,
  loading = false
}) => {
  const gridStyles = SURVEY_TABLE_STYLES.gridContainer;

  if (loading) {
    return (
      <div role="table" aria-label="Respuestas de encuesta">
        <div style={gridStyles}>
          <SurveyTableHeaders fields={survey?.fields || []} />
        </div>
        <div style={{ ...gridStyles, borderTop: "1px solid #e0e4ea" }}>
          <GridTableDatum>
            <Center horizontal="left" vertical="center">
              Cargando respuestas...
            </Center>
          </GridTableDatum>
        </div>
      </div>
    );
  }

  return (
    <div role="table" aria-label="Respuestas de encuesta">
      {/* Table Headers */}
      <SurveyTableContainer role="row">
        <SurveyTableHeaders fields={survey?.fields || []} />
      </SurveyTableContainer>

      {/* Table Content */}
      {!allSurveyAnswers?.has_answers ? (
        <SurveyTableEmptyRow role="row">
          <GridTableDatum role="cell">
            <Center horizontal="left" vertical="center">
              Aún no recibiste ninguna respuesta.
            </Center>
          </GridTableDatum>
        </SurveyTableEmptyRow>
      ) : (
        <div role="rowgroup">
          {allSurveyAnswers?.survey_answers?.map((surveyAnswers, index) => (
            <SurveyAnswerRow
              key={`survey-answer-${index}`}
              surveyAnswers={surveyAnswers}
              index={index}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SurveyAnswersTable;
